import { FC } from 'react';
import { IconSVG, IconSVGComponentProps } from '../IconComponent';

export const TrustPilotStars: FC<IconSVGComponentProps> = ({ ...props }) => {
    return (
        <IconSVG
            width="107"
            height="20"
            viewBox="0 0 107 20"
            fill="none"
            stroke="none"
            {...props}
        >
            <g clipPath="url(#clip0_2297_1365)">
                <path d="M20.1667 0H0.166748V20H20.1667V0Z" fill="#219653" />
                <path d="M41.8334 0H21.8334V20H41.8334V0Z" fill="#219653" />
                <path d="M63.5001 0H43.5001V20H63.5001V0Z" fill="#219653" />
                <path d="M85.1667 0H65.1667V20H85.1667V0Z" fill="#219653" />
                <path d="M106.833 0H86.8334V20H106.833V0Z" fill="#219653" />
                <path
                    d="M10.1665 13.479L13.2082 12.7082L14.479 16.6249L10.1665 13.479ZM17.1665 8.41655H11.8123L10.1665 3.37488L8.52067 8.41655H3.1665L7.49984 11.5415L5.854 16.5832L10.1873 13.4582L12.854 11.5415L17.1665 8.41655Z"
                    fill="white"
                />
                <path
                    d="M31.8331 13.479L34.8748 12.7082L36.1456 16.6249L31.8331 13.479ZM38.8331 8.41655H33.479L31.8331 3.37488L30.1873 8.41655H24.8331L29.1665 11.5415L27.5206 16.5832L31.854 13.4582L34.5206 11.5415L38.8331 8.41655Z"
                    fill="white"
                />
                <path
                    d="M53.4998 13.479L56.5414 12.7082L57.8123 16.6249L53.4998 13.479ZM60.4998 8.41655H55.1456L53.4998 3.37488L51.8539 8.41655H46.4998L50.8331 11.5415L49.1873 16.5832L53.5206 13.4582L56.1873 11.5415L60.4998 8.41655Z"
                    fill="white"
                />
                <path
                    d="M75.1665 13.479L78.2082 12.7082L79.479 16.6249L75.1665 13.479ZM82.1665 8.41655H76.8123L75.1665 3.37488L73.5207 8.41655H68.1665L72.4998 11.5415L70.854 16.5832L75.1873 13.4582L77.854 11.5415L82.1665 8.41655Z"
                    fill="white"
                />
                <path
                    d="M96.8331 13.479L99.8748 12.7082L101.146 16.6249L96.8331 13.479ZM103.833 8.41655H98.479L96.8331 3.37488L95.1873 8.41655H89.8331L94.1665 11.5415L92.5206 16.5832L96.854 13.4582L99.5206 11.5415L103.833 8.41655Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_2297_1365">
                    <rect
                        width="106.667"
                        height="20"
                        fill="white"
                        transform="translate(0.166748)"
                    />
                </clipPath>
            </defs>
        </IconSVG>
    );
};
